export default __webpack_public_path__ + "static/media/Certilytics-Logo-Icons-2.e8b86d85.svg";